export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7955.df8163f4.jpg";